import { sanitizeUrl } from "../utils/sanitizeUrl";

AFRAME.registerComponent("link-oninteract", {
    schema: {
        target: {
            default: "Open",
        },
        newwindow: {
            default: true,
        },
    },
    init: function () {
        // Add the "ui" class to the element
        this.el.classList.add("ui");

        // Add a "mousedown" event listener
        this.el.addEventListener("mousedown", (event) =>
            this.onInteract(event)
        );

        // If the element has the "staticbody" class, add a "beginContact" event listener
        if (this.el.classList.contains("staticbody")) {
            this.el.sceneEl.systems.physics.driver.world.addEventListener(
                "beginContact",
                (event) => {
                    const { bodyA: bodyA, bodyB: bodyB } = event;

                    if (
                        this.el.id !== bodyB.el.id &&
                        this.el.id !== bodyA.el.id
                    ) {
                        return;
                    }

                    this.onInteract();
                }
            );
        }
    },
    onInteract: function () {
        if (this.el.sceneEl.classList.contains("assetsPanel")) {
            return;
        }

        if (this.data.target.startsWith("http") && this.data.newwindow) {
            window.open(sanitizeUrl(this.data.target), null, "noopener");
        } else if (
            this.data.target.startsWith("http") &&
            !this.data.newwindow
        ) {
            window.location = this.data.target;
        } else {
            window.location = this.data.target + "/in";
        }
    },
    remove: function () {
        this.el.removeEventListener("mousedown", (event) =>
            this.onInteract(event)
        );
    },
    update: function (oldData) {
        if (!oldData) {
            return;
        }

        const newData = this.data;
        AFRAME.utils.diff(newData, oldData);
    },
    tick: function (time, timeDelta) {},
});
